import React, { useState, useEffect, useRef, useMemo } from "react";
import DropDownInFinanceReportComponentHeader from "./DropDownInFinanceReportComponentHeader";

import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import useDownloadPDF from "../hooks/useDownloadPDF";
import { Loader , FileText, Printer} from "lucide-react";
import ExportExcelButton from "../TrialBalanceModeComponentFolder/ExportExcelButton";
import { exportTrialBalanceToExcel } from "../TrialBalanceModeComponentFolder/excelExportUtils";

export default function FinancialReportBaseComponentHeader(props) {
  const {
    selectedMode,
    parentDetails,
    setParentDetails,
    PDFComponent,
    datagetTrialBalanceReport,
    selected_mode_table_structure,
    datagetgetFinancialDateApi,
  } = props;

  console.log("PDFComponent--> parentDetails--", parentDetails);

  const canRenderPDF = PDFComponent && typeof PDFComponent === "function"; // ✅ check if it's a valid component

  console.log(
    "datagetTrialBalanceReport in Fin header",
    datagetTrialBalanceReport,
  );
  console.log(
    "parentDetails array",
    parentDetails,
    parentDetails.mode_list_array.filter((item) => item.is_selected),
  );

  let default_mode = "";
  if (parentDetails.mode_list_array) {
    if (parentDetails.mode_list_array.filter((item) => item.is_selected)) {
      default_mode = parentDetails.mode_list_array.filter(
        (item) => item.is_selected,
      )[0]?.mode_code;
    }
  }
  const [mode, setMode] = useState(default_mode);

  let default_department = "";
  if (parentDetails.department_list_array) {
    if (
      parentDetails.department_list_array.filter((item) => item.is_selected)
    ) {
      default_department = parentDetails.department_list_array.filter(
        (item) => item.is_selected,
      )[0].department_name;
    }
  }

  const [dept, setDept] = useState(default_department);
  const [checkbox_list_from_parent, setCheckbox_list_from_parent] = useState(
    parentDetails.checkbox_list_array,
  );
  const [switches, setSwitches] = useState(
    parentDetails.toggle_button_list_array,
  );

  useEffect(() => {
    if (mode) {
      let new_mode_array = parentDetails.mode_list_array.map((item) => {
        if (item.mode_code === mode) {
          return { ...item, is_selected: true };
        } else {
          return { ...item, is_selected: false };
        }
      });

      console.log(
        "parent clicked_mode new_mode_array ",
        parentDetails.mode_list_array,
        mode,
        new_mode_array,
      );

      setParentDetails((prev) => ({
        ...prev,
        mode_list_array: new_mode_array,
      }));
    }
  }, [mode]);

  const handleCheckbox = (e) => {
    let newArray = checkbox_list_from_parent.map((item) => {
      if (item.checkbox_name === e.target.name) {
        return { ...item, is_selected: !item.is_selected };
      } else {
        return item;
      }
    });
    setCheckbox_list_from_parent(newArray);

    setParentDetails((prev) => ({ ...prev, checkbox_list_array: newArray }));
  };

  const handleSwitch = (e) => {
    let newArray = switches.map((item) =>
      item.toggle_name === e.target.name
        ? { ...item, is_selected: !item.is_selected }
        : item,
    );
    setSwitches(newArray);

    setParentDetails((prev) => ({
      ...prev,
      toggle_button_list_array: newArray,
    }));
  };

  const { generateAndDownload, isGenerating } = useDownloadPDF();

  const handlePrintPDF = async () => {
    if (!datagetTrialBalanceReport || datagetTrialBalanceReport.length === 0)
      return;
    if (!PDFComponent) return;

    console.log(
      "datagetTrialBalanceReport handlePrintPDF!!",
      datagetTrialBalanceReport,
    );

    // Open a blank window first to avoid popup block
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Popup blocked! Please allow popups for this site.");
      return;
    }

    // Render your PDF component
    const doc = (
      <PDFComponent
        key={selectedMode}
        data={datagetTrialBalanceReport}
        parentDetails={parentDetails}
        selected_mode_table_structure={selected_mode_table_structure}
        clientDetails={{
          name: "test",
          address: "test address",
          phone: "1234567890",
          email: "test@email",
          footerText: "test footer",
        }}
      />
    );

    // Generate PDF as blob
    const asPdf = pdf(doc);
    const blob = await asPdf.toBlob();

    // Create blob URL
    const blobUrl = URL.createObjectURL(blob);

    // Load the PDF in the blank window
    printWindow.location.href = blobUrl;

    // Optional: wait until the PDF loads, then print
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };
  };

  const isRowEmpty = (r) => {
    const vals = [r.OPENBAL, r.DEBIT, r.CREDIT, r.BALANCE];
    return vals.every((v) => v === null || v === 0);
  };

  const handleExportExcel = () => {
    const selectedModeMeta = selected_mode_table_structure?.find(
      (item) => item.mode_table_name === parentDetails?.mode_list_array?.find((m) => m.is_selected)?.mode_name
    );

    const visibleColumns = selectedModeMeta?.mode_table_columns?.filter(
      (col) => col.column_key_from_api !== "NODE" && col.column_key_from_api !== "GROUP CODE"
    ) || [];

    const filteredData = (datagetTrialBalanceReport || []).filter((r) => !isRowEmpty(r));

    exportTrialBalanceToExcel({
      data: filteredData,
      columns: visibleColumns,
      groupKeys: ["NODE", "GROUP CODE"],
      valueKeys: ["OPENBAL", "DEBIT", "CREDIT", "BALANCE"],
      deriveFromBalance: false,
      fileName: selectedModeMeta?.mode_table_name || "TrialBalanceReport",
      sheetName: "Trial Balance",
    });
  };

  const isDateFromDisabled = !parentDetails.checkbox_list_array.some(
    (item) =>
      item?.checkbox_name === "Activate From Date For Movement" &&
      item?.is_selected,
  );

  console.log("isDateFromDisabled ", isDateFromDisabled);

  const handleDownload = () => {
    if (!PDFComponent || !datagetTrialBalanceReport?.length) return;

    const doc = (
      <PDFComponent
        data={datagetTrialBalanceReport}
        parentDetails={parentDetails}
        selected_mode_table_structure={selected_mode_table_structure}
        clientDetails={{
          name: "test",
          address: "test address",
          phone: "1234567890",
          email: "test@email",
          footerText: "test footer",
        }}
      />
    );

    generateAndDownload(doc, `${parentDetails.report_name}.pdf`);
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-4">
        {parentDetails.report_name}
      </h2>

      {/* Filters Section */}
      <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
        {/* Mode */}
        <DropDownInFinanceReportComponentHeader
          label="Mode"
          options={parentDetails.mode_list_array}
          selected={mode}
          setSelected={setMode}
          labelKey="mode_name"
          valueKey="mode_code"
        />

        {/* Date From */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Date From
          </label>
          <input
            type="date"
            value={parentDetails.from_date}
            onChange={(e) => {
              let newFromDate = e.target.value;

              const fyStartDate = new Date(
                datagetgetFinancialDateApi[0]?.fystart?.split("T")[0],
              );
              const toDate = new Date(parentDetails.to_date);
              const todayDate = new Date();

              const selectedDate = new Date(newFromDate);

              if (selectedDate < fyStartDate) {
                alert(
                  `From Date cannot be before Fiscal Start (${fyStartDate.toISOString().split("T")[0]})`,
                );
                newFromDate = fyStartDate.toISOString().split("T")[0];
              } else if (selectedDate > toDate) {
                alert(
                  `From Date cannot be after To Date (${toDate.toISOString().split("T")[0]})`,
                );
                newFromDate = toDate.toISOString().split("T")[0];
              } else if (selectedDate > todayDate) {
                alert(
                  `From Date cannot be in the future (${todayDate.toISOString().split("T")[0]})`,
                );
                newFromDate = todayDate.toISOString().split("T")[0];
              }

              setParentDetails((prev) => ({ ...prev, from_date: newFromDate }));
            }}
            disabled={isDateFromDisabled}
            className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 ${isDateFromDisabled ? "bg-gray-100 cursor-not-allowed" : ""
              }`}
          />
        </div>

        {/* Date To */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Date To
          </label>
          <input
            type="date"
            value={parentDetails.to_date}
            onChange={(e) => {
              let newToDate = e.target.value;

              console.log("datagetgetFinancialDateApi ", datagetgetFinancialDateApi);

              const fyEndDate = new Date(
                datagetgetFinancialDateApi[0]?.ftend?.split("T")[0],
              );
              const fromDate = new Date(parentDetails.from_date);
              const todayDate = new Date();

              let maxAllowedDate =
                fyEndDate > todayDate ? todayDate : fyEndDate;

              const selectedDate = new Date(newToDate);

              if (selectedDate > maxAllowedDate) {
                alert(
                  `Selected date cannot be after ${maxAllowedDate.toISOString().split("T")[0]}`,
                );
                newToDate = maxAllowedDate.toISOString().split("T")[0];
              } else if (selectedDate < fromDate) {
                alert(
                  `Selected date cannot be before From Date (${fromDate.toISOString().split("T")[0]})`,
                );
                newToDate = fromDate.toISOString().split("T")[0];
              }

              setParentDetails((prev) => ({ ...prev, to_date: newToDate }));
            }}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {/* Dept Code */}
        <DropDownInFinanceReportComponentHeader
          label="Dept Code"
          options={parentDetails.department_list_array}
          selected={dept}
          setSelected={setDept}
          labelKey="department_name"
          valueKey="department_code"
        />



        <div className="md:col-span-2 flex items-end justify-end gap-2">
          <ExportExcelButton onClick={handleExportExcel} />

          {canRenderPDF && datagetTrialBalanceReport?.length > 0 && (
            <button
              onClick={handleDownload}
              disabled={isGenerating}
              className={`flex items-center gap-2 px-3.5 py-2 text-xs font-semibold rounded-md shadow-sm transition-all duration-150 text-white ${isGenerating
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-red-600 hover:bg-red-700 active:bg-red-800"
                }`}
            >
              {isGenerating ? (
                <>
                  <Loader className="animate-spin" size={16} />
                  <span>Generating PDF...</span>
                </>
              ) : (
                <>
                  <FileText size={16} />
                  <span>Download PDF</span>
                </>
              )}
            </button>
          )}

          <button
            onClick={handlePrintPDF}
            className="flex items-center gap-2 px-3.5 py-2 text-xs font-semibold rounded-md shadow-sm border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 active:bg-gray-100 transition-all duration-150"
          >
            <Printer size={16} />
            <span>Print</span>
          </button>
        </div>


      </div>

      <div style={{ display: "flex" }}>
        <div style={{ display: "flex" }}>
          {/* Checkboxes */}
          {checkbox_list_from_parent?.map((item) => {
            return (
              <div key={item.checkbox_name} className="mt-4 ms-2 flex flex-wrap gap-4">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    name={item.checkbox_name}
                    checked={item.is_selected}
                    onChange={handleCheckbox}
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  <span className="ml-2 text-sm text-gray-700">
                    {item.checkbox_name}
                  </span>
                </label>
              </div>
            );
          })}
        </div>

        <div style={{ display: "flex" }} className="ms-2">
          {/* Toggle Switches */}
          {switches?.map((item) => {
            return (
              <div key={item.toggle_name} className="mt-3 ms-2 flex flex-wrap gap-6">
                <label className="flex items-center cursor-pointer">
                  <span className="text-sm text-gray-700 mr-2">
                    {item.toggle_name}
                  </span>
                  <input
                    type="checkbox"
                    name={item.toggle_name}
                    checked={item.is_selected}
                    onChange={handleSwitch}
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-gray-200 rounded-full peer-checked:bg-blue-600 relative after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5" />
                </label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}